import { type RequestedResources } from '../../models/auth/requested-resources'

// Page permissions whitelist
export const PAGE_PERMISSIONS: Record<string, RequestedResources> = {
  '/funding_rate': { read: ['ops-monitoring'] },
  '/risk': { read: ['ops-monitoring'] },
  '/balance': { read: ['ops-monitoring'] },
  '/exposure': { read: ['ops-monitoring'] },
  '/exposure_statistic': { read: ['ops-monitoring'] },
  '/balance_plus': { read: ['ops-monitoring', 'strategy-management'] },
  '/transfer': { read: ['transfer-control'], write: ['transfer-control'] },
  '/transfer_bn': { read: ['transfer-control'], write: ['transfer-control'] },
  '/withdraw': { read: ['transfer-control'], write: ['transfer-control'] },
  '/reconciliation': { read: ['strategy-management'], write: ['strategy-management'] },
  '/strategy_status': { read: ['configuration', 'ops-monitoring'], write: [] },
  '/strategy': {
    read: ['configuration', 'strategy-management', 'oms-management', 'gateway-management'],
    write: ['strategy-management', 'oms-management', 'gateway-management']
  },
}
